import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Bikalpa Sharma </span>
            from <span className="purple"> Kathmandu, Nepal. </span> 
             I am a student pursuing Bsc. CSIT in Tribhuwan University in Bhaktapur Multiple Campus. I am fluent in Wordpress, JavaScript, CSS , HTML, C ,C++ and now learning Python. I have experience in Adobe Photoshop and Premiere pro too.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            " Don't give up before the miracle happens...! " {" "}
          </p>
          <footer className="blockquote-footer">Buzz</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
